<template>
  <ul
    v-if="model.pageCount>1"
    class="pagination"
    v-bind:class="paginationClass"
    ref="pagination"
    :data-path="model.$form.testPath ? model.$path : undefined"
  >
    <li class="disabled">
      <a>od {{startNumber}} do {{endNumber}} z {{maxNumber}}</a>
    </li>
    <li v-bind:class="{'disabled':model.pageNumber==0}">
      <a href="javascript:void(0);" @click="setPage(model.pageNumber-1)">
        <i class="fa" v-bind:class="previousIconClass"></i>
      </a>
    </li>
    <li
      v-for="(targetPage, index) in elements"
      :key="index"
      v-bind:class="{active:(targetPage==model.pageNumber), 'disabled':(targetPage==undefined)}"
    >
      <a
        v-if="targetPage!=undefined"
        href="javascript:void(0);"
        @click="setPage(targetPage)"
      >{{targetPage+1}}</a>
      <span v-if="targetPage==undefined">...</span>
    </li>

    <li v-bind:class="{'disabled':model.pageNumber>=model.pageCount-1}">
      <a href="javascript:void(0);" @click="setPage(model.pageNumber+1)">
        <i class="fa" v-bind:class="nextIconClass"></i>
      </a>
    </li>
  </ul>
</template>

<script>
import modelMixin from '../mixins/modelMixin';

export default {
  name: 'w-pagination',
  mixins: [modelMixin],
  props: {
    borderless: {type: Boolean, default: false},
    size: {type: String, default: ''}
  },
  data() {
    return {
      localPage: 0
    };
  },
  methods: {
    setPage(targetPage) {
      this.model.pageNumber = targetPage;
    },
    scrollToElement() {
      const rect = this.$refs.pagination.getBoundingClientRect();
      window.scroll(0, document.documentElement.scrollTop + rect.y + rect.height - window.innerHeight);
    }
  },
  computed: {
    startNumber: {
      get() {
        return this.model.pageNumber * this.model.pageSize + 1;
      }
    },
    endNumber: {
      get() {
        if (this.model.pageNumber + 1 === this.model.pageCount) {
          return this.maxNumber - (this.model.pageCount - 1) * this.model.pageSize + this.model.pageSize * this.model.pageNumber;
        }
        return this.model.pageSize * (this.model.pageNumber + 1);
      }
    },
    maxNumber: {
      get() {
        return this.model.$items.length;
      }
    },
    elements: {
      get() {
        const list = [0];
        const pageMax = this.model.pageCount - 1;
        let mini = this.model.pageNumber > 2 ? this.model.pageNumber - 1 : 1;
        if (this.model.pageNumber + 2 >= pageMax) {
          mini = pageMax - 4;
        }
        if (mini < 1) {
          mini = 1;
        }

        if (mini > 1) {
          list.push(undefined);
        }

        let maxi = this.model.pageNumber < 3 ? 5 : this.model.pageNumber + 2;
        if (maxi >= pageMax) {
          maxi = pageMax;
        }

        for (let i = mini; i < maxi; i++) {
          list.push(i);
        }
        if (maxi < pageMax) {
          list.push(undefined);
        }
        list.push(pageMax);
        return list;
      }
    },

    paginationClass: {
      get() {
        const result = [];
        switch (this.size) {
          case 'large':
            result.push('pagination-lg');
            break;
          case 'small':
            result.push('pagination-sm');
            break;
        }
        if (this.borderless) {
          result.push('pagination-alt');
        }
        return result;
      }
    },
    previousIconClass: {
      get() {
        const result = [];
        if (this.borderless) {
          result.push('fa-angle-left');
        } else {
          result.push('fa-chevron-left');
        }
        return result;
      }
    },
    nextIconClass: {
      get() {
        const result = [];
        if (this.borderless) {
          result.push('fa-angle-right');
        } else {
          result.push('fa-chevron-right');
        }
        return result;
      }
    }
  },
  watch: {
    'model.pageNumber'() {
      console.log('model changed');
      this.$nextTick(() => {
        this.scrollToElement();
      });
    }
  }
};
</script>

<style>
.pagination.pagination-alt > li > a,
.pagination.pagination-alt > li > span {
  box-shadow: none;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  border: none;
  margin-left: -1px;
}
.pagination.pagination-alt > li:first-child > a {
  padding-left: 12px;
}
</style>
